export default __webpack_public_path__ + "static/media/document-multiple.5fff6073.png";